const styles = (color, indicatorColor) => ({
  tabLabel: {
    fontFamily: "DM Sans",
    fontSize: "12px",
    fontWeight: 500,
    lineHeight: "16px",
    textAlign: "center",
    textTransform: "capitalize",
    padding: "6px 8px",
    // fix-segment-environment-1024-text-wrap: "auto" let MUI's fullWidth variant
    // squeeze a tab (e.g. a 6-tab strip in a ~220px side pane at 1024px) down to a
    // few px wide, at which point whiteSpace:normal's default word-wrap broke each
    // label letter-by-letter ("Upload" -> "U/p/l/o/a/d"). A real minimum plus
    // nowrap (below) keeps every label on one line; MUITabs auto-resolves to
    // "scrollable" once the strip can't fit that minimum (see Tabs/index.jsx).
    minWidth: "48px",
    minHeight: "auto",
    whiteSpace: "nowrap",
    overflowWrap: "normal",
    "&.Mui-selected": {
      color: color,
    },
  },
  tabContainer: {
    backgroundColor: indicatorColor,
  },
});

export default styles;
